module.exports = __webpack_public_path__ + "media/about/warehouse-deaae648.jpg";